export default {"src":"/_next/static/media/campass-border.f35393a9.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};